import styles from './LabelDots.module.css'

type LabelDotsProps = {MAX_DISPLAYED_LABELS?: number; labelColors: string[]}

export const LabelDots = ({MAX_DISPLAYED_LABELS = 5, labelColors}: LabelDotsProps) => {
  return (
    <div className={styles.labelDotsContainer}>
      {labelColors.slice(0, MAX_DISPLAYED_LABELS).map((color, i) => (
        <div
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={`${i}-${color}`}
          style={{backgroundColor: `#${color}`}}
          className={styles.labelDot}
        />
      ))}
    </div>
  )
}
